import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import Icon from "@mdi/react";
import { mdiLoading } from "@mdi/js";
import axios from "axios";
import Styles from "./FormDetailAvis.scss";

const FormDetailAvis = (props) => {
    const [servicesWithState, setServicesWithState] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [formRef, setFormRef] = useState({});
    const [loading, setLoading] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    // Sync formRef with props.formData, but avoid overwriting during an update
    useEffect(() => {
        if (!isUpdating) {
            setFormRef(props.formData || {});
        }
    }, [props.formData]);

    useEffect(() => {
        setLoading(true);
        fetchServiceTypes()
            .then(() => fetchServices())
            .finally(() => setLoading(false));
    }, [props.formData]);

    const fetchServiceTypes = async () => {
        try {
            const result = await axios.post("/Api/service_types", {});
            if (result.data) setServiceTypes(result.data);
        } catch (e) {
            console.error(e);
        }
    };

    const fetchServices = async () => {
        try {
            const result = await axios.post("/Api/services/" + props.formData.id, {});
            if (result.data?.data) setServicesWithState(result.data.data);
        } catch (e) {
            console.error(e);
        }
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setFormRef((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const UpdateForm = async (e) => {
        const payload = {
            ...formRef,
            [e.target.name]: e.target.value,
        };

        setIsUpdating(true); // Prevent overwrites during update

        try {
            const response = await axios.post(`/Api/Form_ref/detail/${formRef.id}/update`, payload);

            // Immediately update Redux state and local state
            props.setCurrentDetailForm(response.data);
            setFormRef(response.data);

            toast.success("Données mises à jour avec succès");
        } catch (error) {
            console.error("Erreur lors de la mise à jour :", error);
            toast.error("Une erreur est survenue");
        } finally {
            setIsUpdating(false); // Re-enable prop updates
        }
    };

    const handleToggleService = async (serviceType) => {
        const activeService = servicesWithState.find((s) => s.code === serviceType.code);

        try {
            if (activeService) {
                await axios.delete("/Api/services/" + activeService.id);
                toast.success("Service désactivé avec succès");
            } else {
                await axios.put("/Api/services_state/" + formRef.id, {
                    service_type_id: serviceType.id,
                    date_demande: new Date(),
                });
                toast.success("Service activé avec succès");
            }

            await fetchServices(); // Refresh service list
        } catch (e) {
            toast.error("Une erreur est survenue lors de la modification du service");
        }
    };

    const renderServiceRow = (serviceType, index) => {
        const activeService = servicesWithState.find((s) => s.code === serviceType.code);
        return (
            <tr key={index}>
                <td className={"text-left"}>
                    <div className="custom-control custom-switch">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            style={{ cursor: "pointer" }}
                            onChange={() => handleToggleService(serviceType)}
                            checked={!!activeService}
                            id={serviceType.code}
                        />
                        <label
                            className="custom-control-label ue-check-service-label"
                            htmlFor={serviceType.code}
                        >
                            {serviceType.label}
                        </label>
                    </div>
                </td>
            </tr>
        );
    };

    return (
        <div className={"d-flex flex-column justify-content-center items-center ue-form-detail-avis mr-3 pl-3 pr-3"}>
            <div id={"service_list_title"} className={"text-left"} style={{ fontWeight: "bold", paddingTop: "20px" }}>
                Validation
            </div>
            <div
                className={
                    "d-flex flex-row my-2 w-100 text-center justify-content-between align-items-center text-dark"
                }
            >
                {loading ? (
                    <div className={"d-flex w-100 justify-content-center items-center"}>
                        <Icon path={mdiLoading} spin={true} size={1.5} color={"var(--theme-primary)"} />
                    </div>
                ) : (
                    <div className={"ue-form-detail-avis-list"}>
                        <table className="table table-borderless text-dark ">
                            <tbody className={"text-dark"}>
                                {serviceTypes.length ? (
                                    serviceTypes.map((serviceType, index) =>
                                        renderServiceRow(serviceType, index)
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan={2}>
                                            <div
                                                className={
                                                    "d-flex w-100 justify-content-center items-center"
                                                }
                                            >
                                                <p className={"text-center"}>Aucune donnée disponible</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="form-group ue-form-goup-input d-flex flex-column justify-content-start w-100">
                            <label className={"text-center text-md-left ue-input-label_inside"}>
                                Observations
                            </label>
                            <textarea
                                className="form-control pt-3"
                                name="comment"
                                rows="8"
                                onChange={handleOnChange}
                                onBlur={UpdateForm}
                                value={formRef.comment || ""}
                            />
                        </div>
                        
                    </div>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        role: state.MeReducer.role,
        centerPageArg: state.DashboardReducer.centerPageArg,
        uiThem: state.AppReducer.uiThem,
        currentDetailForm: state.FormsReducer.currentDetailForm,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        showCenterSection: (e) => dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
        setCurrentCenterPage: (e) => dispatch({ type: "SET_CURRENT_PAGE", data: e }),
        setCurrentDetailForm: (e) => dispatch({ type: "SET_CURRENT_DETAIL_FORM", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(FormDetailAvis);
